const items = [
  "ASNT Level III Auditing",
  "PAUT Ultrasonic Testing",
  "VT / MT / PT Inspection",
  "Radiographic Film Auditing",
  "QA/QC Oversight",
  "API & ASME Compliance",
  "Field Reporting",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/[0.08] bg-coal py-5" data-testid="capability-marquee">
      <div className="flex w-max animate-marquee-drift items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-lg font-semibold uppercase tracking-[0.2em] text-zinc-500">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-apx" />
          </span>
        ))}
      </div>
    </div>
  );
}
